import { Popover as Ark } from '@ark-ui/react/popover';
import { Portal } from '@ark-ui/react/portal';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface PopoverProps {
  trigger: ReactNode;
  children: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
  gutter?: number;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
  /** Не уводить фокус в содержимое (для палитр на холсте). */
  autoFocus?: boolean;
  portalled?: boolean;
}

export function Popover({ trigger, children, side = 'bottom', align = 'center', gutter = 8, open, onOpenChange, className, autoFocus = false, portalled = true }: PopoverProps) {
  const content = (
    <Ark.Positioner className="z-[1050]">
      <Ark.Content
        className={cn(
          'glass p-2 outline-none data-[state=open]:animate-pop-in',
          className,
        )}
      >
        {children}
      </Ark.Content>
    </Ark.Positioner>
  );
  return (
    <Ark.Root
      open={open}
      onOpenChange={(d) => onOpenChange?.(d.open)}
      positioning={{ placement: align === 'center' ? side : `${side}-${align}`, gutter }}
      autoFocus={autoFocus}
      lazyMount
      unmountOnExit
      portalled={portalled}
    >
      <Ark.Trigger asChild>{trigger}</Ark.Trigger>
      {portalled ? <Portal>{content}</Portal> : content}
    </Ark.Root>
  );
}
